import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import RoundedButton from 'Components/ComponentLibrary/Components/Uncategorized/RoundedButton';
import { DS_SIZE_MAP } from 'Components/ComponentLibrary/DesignSystem/sizes';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import { useSnackbarContext } from 'Context/SnackbarContext';

const styles = (theme) => ({
  root: {},
  backContainer: {
    position: 'absolute',
    top: theme.spacing(0.5),
    left: theme.spacing(0.5),
  },
  contentContainer: {
    paddingTop: theme.spacing(4),
  },
});

const IdentityVerificationDecisionLayout = ({
  className,
  classes,
  onDecisionSubmitted,
  onBack,
}) => {
  const {
    resource,
  } = useMetaLayoutContext();
  const { displayErrorMessage } = useSnackbarContext();

  const handleSubmit = async () => {
    try {
      await resource.submit();
      onDecisionSubmitted();
    } catch (err) {
      displayErrorMessage(err, err.errors);
    }
  };

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <div className={classes.backContainer}>
        <IconButton
          onClick={() => onBack(resource)}
          aria-label={'go back button'}
          title={'Go Back'}
          color={'primary'}
          icon={NavigateBeforeIcon}
        />
      </div>
      <div className={classes.contentContainer}>
        <MetaField className={classes.field} attr="comment" />
      </div>
      <RoundedButton
        className={classes.actionButton}
        onClick={handleSubmit}
        fullWidth
        variant={'contained'}
        color={'primary'}
        size={DS_SIZE_MAP.xxs}
      >
        {'Submit'}
      </RoundedButton>
    </Box>
  );
};

IdentityVerificationDecisionLayout.defaultProps = {
  className: '',
};

IdentityVerificationDecisionLayout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onDecisionSubmitted: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default withStyles(styles)(IdentityVerificationDecisionLayout);
